import AdyenLogo from './AdyenLogo';
import MollieLogo from './MollieLogo';
import StripeLogo from './StripeLogo';
const distributionPartners = [
    'adyen',
    'mollie',
    'stripe'
];
const distributionPartnerLogoMap = {
    adyen: AdyenLogo,
    mollie: MollieLogo,
    stripe: StripeLogo
};
export default distributionPartnerLogoMap;
